import { DataGridField } from '../data-grid/data-grid-field.js'
import { ColumnConfig, FieldEditor, GristRecord } from '../types.js'
import { OxGristEditor } from './ox-grist-editor.js'
import { OxGristEditorCheckbox } from './ox-grist-editor-checkbox.js'
import { OxGristEditorColor } from './ox-grist-editor-color.js'
import { OxGristEditorDate } from './ox-grist-editor-date.js'
import { OxGristEditorDateTime } from './ox-grist-editor-datetime.js'
import { OxGristEditorEmail } from './ox-grist-editor-email.js'
import { OxGristEditorFile } from './ox-grist-editor-file.js'
import { OxGristEditorImage } from './ox-grist-editor-image.js'
import { OxGristEditorMonth } from './ox-grist-editor-month.js'
import { OxGristEditorMultipleSelect } from './ox-grist-editor-multiple-select.js'
import { OxGristEditorNumber } from './ox-grist-editor-number.js'
import { OxGristEditorPassword } from './ox-grist-editor-password.js'
import { OxGristEditorSelect } from './ox-grist-editor-select.js'
import { OxGristEditorTel } from './ox-grist-editor-tel.js'
import { OxGristEditorText } from './ox-grist-editor-text.js'
import { OxGristEditorTextarea } from './ox-grist-editor-textarea.js'
import { OxGristEditorTime } from './ox-grist-editor-time.js'
import { OxGristEditorTree } from './ox-grist-editor-tree.js'
import { OxGristEditorWeek } from './ox-grist-editor-week.js'
import { OxGristEditorVarname } from './ox-grist-editor-varname.js'
import { OxGristEditorJson5 } from './ox-grist-editor-json5.js'
import { OxGristEditorTimezone } from './ox-grist-editor-timezone.js'
import { OxGristEditorSecret } from './ox-grist-editor-secret.js'
import { OxGristEditorTextSelect } from './ox-grist-editor-text-select.js'

var EDITORS: { [name: string]: { new (): OxGristEditor } } = {
  string: OxGristEditorText,
  text: OxGristEditorText,
  textarea: OxGristEditorTextarea,
  email: OxGristEditorEmail,
  tel: OxGristEditorTel,
  password: OxGristEditorPassword,
  integer: OxGristEditorNumber,
  float: OxGristEditorNumber,
  number: OxGristEditorNumber,
  select: OxGristEditorSelect,
  boolean: OxGristEditorCheckbox,
  checkbox: OxGristEditorCheckbox,
  month: OxGristEditorMonth,
  week: OxGristEditorWeek,
  date: OxGristEditorDate,
  time: OxGristEditorTime,
  datetime: OxGristEditorDateTime,
  color: OxGristEditorColor,
  progress: OxGristEditorNumber,
  link: OxGristEditorText,
  image: OxGristEditorImage,
  file: OxGristEditorFile,
  'string[]': OxGristEditorMultipleSelect,
  tree: OxGristEditorTree,
  varname: OxGristEditorVarname,
  json5: OxGristEditorJson5,
  timezone: OxGristEditorTimezone,
  secret: OxGristEditorSecret,
  'text-select': OxGristEditorTextSelect
}

export function registerEditor(type: string, editor: { new (): OxGristEditor }) {
  EDITORS[type] = editor
}

export function unregisterEditor(type: string) {
  delete EDITORS[type]
}

export function getEditors(): { [name: string]: { new (): OxGristEditor } } {
  return { ...EDITORS }
}

export function getEditor(type: string): FieldEditor {
  if (typeof type == 'function') {
    return type
  }

  return function (value: any, column: ColumnConfig, record: GristRecord, rowIndex: number, field: DataGridField) {
    var clazz = EDITORS[type || 'text'] || OxGristEditorText

    var element = new clazz()

    element.value = value
    element.record = record
    element.column = column
    element.row = rowIndex
    element.field = field

    return element
  }
}
